import { GreenAlertIcon } from "./GreenAlertIcon"

interface ItemsToBringProps {
  items: any
}

const ItemsToBring: React.FC<ItemsToBringProps> = ({ items }) => {
  return (
    <>
      {items.map((item: any) => (
        <div key={item.id} className="item-to-bring">
          <GreenAlertIcon />
          <p className="item-text">{item.text}</p>
          {item.extraDescription ? (
            <div className="extra-info">
              <p>{item.extraDescription}</p>
            </div>
          ) : null}
        </div>
      ))}
    </>
  )
}

export { ItemsToBring }
